import request from 'api/request';

export default function regenerateJoinCode({ id, field }) {
  return request({ url: `/courses/${id}/regenerate/${field}`, method: 'PUT' });
}
